import React, { useEffect, useState, useReducer } from "react";
import styles from "../../BorrowerDetails.module.css";
// import styles from "../../Demo.module.css"
import { url } from "../../../../../App";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { MenuItem, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useBorrowerContext } from "../../store/borrower-details";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import PartlyDisbursedStatus from "./TrancheStatusModal/PartlyDisbursedStatus";

const initialState = {
  esign: false,
  esigned: false,
  enach: false,
  disbursed: false,
  cpvInitiated: false,
  cpvDone: false,
  nbfcSoftApproved: false,
  nbfcApproved: false,
  analystRejected: false,
  managerRejected: false,
  nbfcRejected: false,
  rfd: false,
  dropOff: false,
  cancelled: false,
  closed: false,
  topup: false,
  restructured: false,
  partlyDisbursed: false,
};

const selectedItemReducer = (state, action) => {
  switch (action.type) {
    case "SET_SELECTED_ITEM":
      return {
        ...initialState,
        ...action.payload,
      };
    default:
      return state;
  }
};

const LoanStatusModal = ({
  closeModal,
  loanDetails,
  cpvUpload,
  openLoader,
  closeLoader,
}) => {
  const Navigate = useNavigate();
  const { updateBorrowerData } = useBorrowerContext();
  const { borrowerData } = useBorrowerContext();
  // eslint-disable-next-line
  const [statusTrail, setStatusTrail] = useState({
    isArray: false,
    array: [],
  });
  const email = Cookies.get("Email");
  const token = Cookies.get("Token");

  const [modalLoanStatus, setModalLoanStatus] = useState("");

  const [loanStatusData, setLoanStatusData] = useState([]);

  const [selectedItem, dispatchSelectedItem] = useReducer(
    selectedItemReducer,
    initialState
  );

  const [disbursedVal, setDisbursedVal] = useState({
    refNumber: "",
    disbDate: "",
    notify: false,
  });

  // eslint-disable-next-line
  const [curCpv, setCurCpv] = useState([]);

  const [descValue, setDescValue] = useState("");
  const [utr, setUtr] = useState("");

  const [showFirstModal, setShowFirstModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const fetchStatusTrail = async () => {
      try {
        const { data } = await axios.post(`${url}/loan/statustrail`, {
          token,
          email,
          loan_id: loanDetails.loan_id,
        });
        if (data.logout) {
          toast.error(data.message);
          Navigate("/");
          return;
        }

        setStatusTrail((prevState) => ({
          ...prevState,
          isArray: Array.isArray(data.message),
          array: data.message,
        }));
      } catch (error) {
        console.error(error);
      }
    };
    const fetchLoanStatus = async () => {
      if (!loanDetails?.loanproduct_id) {
        toast.error("Loan product ID is missing.");
        setLoanStatusData([]);
        setModalLoanStatus(loanDetails?.loan_status || "");
        return;
      }

      try {
        const loanProductRes = await axios.post(
          url + "/loanproduct/getsingle",
          {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            loanproduct_id: loanDetails?.loanproduct_id,
          }
        );

        if (!loanProductRes?.data) {
          toast.error("Failed to fetch loan product details.");
          setLoanStatusData([]);
          setModalLoanStatus(loanDetails?.loan_status || "");
          return;
        }

        if (loanProductRes.data[0]?.logout) {
          toast.error(loanProductRes.data[0].message);
          Navigate("/");
          return;
        }

        if (loanProductRes.data.auth === false) {
          toast.error(loanProductRes.data.message || "Unauthorized access.");
          return;
        }

        const loanProductData = Array.isArray(loanProductRes.data)
          ? loanProductRes.data[0]
          : loanProductRes.data.message || loanProductRes.data;

        if (!loanProductData?.workflow_id) {
          toast.error("Workflow ID not found for this loan product.");
          setLoanStatusData([]);
          setModalLoanStatus(loanDetails?.loan_status || "");
          return;
        }

        const { data } = await axios.post(
          `${url}/loan/statusarray`,
          {
            workflow_id: loanProductData.workflow_id,
            current_status: loanDetails?.loan_status,
            token, email
          }
        );

        if (data?.message && Array.isArray(data.message) && data.message.length > 0) {
          setLoanStatusData(data.message);
        } else {
          setLoanStatusData([]);
          setModalLoanStatus(loanDetails?.loan_status || "");
        }
      } catch (error) {
        console.error("Error fetching loan status:", error);
        toast.error(error?.response?.data?.message || error.message || "An error occurred.");
        setLoanStatusData([]);
        setModalLoanStatus(loanDetails?.loan_status || "");
      }
    };

    const updateCurCpv = () => {
      if (borrowerData.cpv.length > 0) {
        const selectedCPV = borrowerData.cpv.find(
          (cpv) => loanDetails.loan_id === cpv.loan_id
        );
        setCurCpv(selectedCPV);
      }
    };

    fetchStatusTrail();
    fetchLoanStatus();
    updateCurCpv();

    //eslint-disable-next-line
  }, [
    loanDetails.loan_id,
    borrowerData,
    setCurCpv,
    setLoanStatusData,
    setStatusTrail,
    token,
    email,
    url,
    Navigate,
  ]);

  const statusChangeHandler = (e) => {
    setModalLoanStatus(e.target.value);
    switch (e.target.value) {
      case "DISBURSED":
        dispatchSelectedItem({
          type: "SET_SELECTED_ITEM",
          payload: { disbursed: true },
        });
        break;
      case "RFD":
        dispatchSelectedItem({
          type: "SET_SELECTED_ITEM",
          payload: { rfd: true },
        });
        break;
      case "PARTLY DISBURSED":
        dispatchSelectedItem({
          type: "SET_SELECTED_ITEM",
          payload: { partlyDisbursed: true },
        });
        break;
      default:
        dispatchSelectedItem({
          type: "SET_SELECTED_ITEM",
          payload: {},
        });
        break;
    }
  };
  const uniqueID = localStorage.getItem("uniqueID");

  const refreshBorrower = async () => {
    const refreshLoans = await axios.post(
      url + "/borrower/borrowertoalldetails",
      {
        token,
        email,
        borrower_uniqueno: uniqueID,
      }
    );

    updateBorrowerData(prev => ({
      ...prev,
      loan: refreshLoans.data.message.loan,
    }));
  };

  const submitLoanStatusHandler = async () => {
    openLoader();
    const statusChangeReq = {
      token: token,
      email: email,
      loan_id: loanDetails.loan_id,
      loan_status: modalLoanStatus,
      loan_status_desc: descValue,
      utr: utr === "" ? disbursedVal.refNumber : utr,
    };

    const precheckRes = await axios.post(
      url + "/loan/status/precheck",
      statusChangeReq
    );

    if (!precheckRes.data.auth) {
      toast.error(precheckRes.data.message);
      closeLoader();
      return;
    }

    if (precheckRes.data.flow === "INCOMPLETE_HANDLED") {
      await refreshBorrower();
      toast.success(precheckRes.data.message);
      closeModal();
      closeLoader();
      return;
    }

    try {
      if (selectedItem.rfd) {
        const rfdReq = {
          loan_id: loanDetails.loan_id,
          borrower_uniqueno: uniqueID,
          email: email,
          token: Cookies.get("Token"),
        };
        try {
          const { data: rfdRes } = await axios.post(
            url + "/loan/check/coapplicant/collateral",
            rfdReq
          );
          if (!rfdRes.auth) {
            toast.error(rfdRes.message);
            if (rfdRes.logout) {
              setTimeout(() => {
                Navigate("/");
              }, 1500);
            }
            closeLoader();
            return;
          }
          toast.success(rfdRes.message);
          closeLoader();
        } catch (err) {
          console.log(err);
          toast.error(err + "from server");
        }
      } else if (selectedItem.disbursed) {
        const disbursedReq = {
          token: token,
          email: email,
          loan_id: loanDetails.loan_id,
          loan_disbursedment_reference: disbursedVal.refNumber,
          loan_disbursedment_date: disbursedVal.disbDate,
          loan_disbursedment_notify: disbursedVal.notify,
          current_loan_status: modalLoanStatus,
        };
        const disbursedRes = await axios.post(
          url + "/loan/disbursedfield",
          disbursedReq
        );
        closeLoader();
        if (!disbursedRes.data.auth) {
          toast.error(disbursedRes.data.message);
          return;
        } else {
          toast.success(disbursedRes.data.message);
        }
      }

      const loanStatusRes = await axios.post(
        url + "/loan/statusupdate",
        statusChangeReq
      );

      if (loanStatusRes?.data?.message === 'Mandate not found' || loanStatusRes?.data?.message === 'Mandate not registered successfully') {
        setShowFirstModal(true);
      }

      if (!loanStatusRes.data.auth) {
        toast.error(loanStatusRes.data.message);
        closeLoader();
        return;
      }

      await refreshBorrower();
      setModalLoanStatus("");
      setDescValue("");
      closeModal();
      toast.success(loanStatusRes.data.message);
      closeLoader();
    } catch (err) {
      console.log("loanStatusRes err", err);
      closeLoader();
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong";
      toast.error(message);
    }
  };

  const handleForceProceed = async () => {
    try {
      let updateStatus = await axios.post(url + "/loan/rfd/statuschange", {
        token: token,
        email: email,
        loanID: loanDetails.loan_id,
        loan_status_desc: descValue,
      });

      if (updateStatus.data.auth) {
        setShowSecondModal(false);
        closeModal();
        await refreshBorrower();
        toast.success(updateStatus.data.message);
      }

    } catch (err) {
      console.error(err);
    }
  };

  const isStatusDisabled = loanStatusData.length === 0;

  return (
    <>
      <ToastContainer />
      <div className={styles.loanstatusModal}>
        <div
          className={styles.loanstatusModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div className={styles.loanstatusModalContent}>
            <h3>Status history of Loan {loanDetails.loan_id} </h3>

            <div style={{ width: "100%", textAlign: "center" }}>
              <h4>History</h4>
            </div>
            <div className={styles.history}>
              {statusTrail.isArray &&
                statusTrail.array.map((data, index) => {
                  return (
                    <div key={index} className={styles.statusHistory}>
                      <p>
                        <span>{data.loan_status_change_officer}</span> changed
                        status to <span>{data.loan_status}</span>
                      </p>
                      <p>
                        <span>{data.loan_status_change_date}</span>
                      </p>
                      <p>
                        <span>Description:</span> {data.loan_status_desc}
                      </p>
                    </div>
                  );
                })}
            </div>
            <div className={styles.textArea}>
              <label htmlFor="">Loan Status<span style={{ color: "red" }}>*</span></label>
              <TextField
                size="small"
                select
                disabled={isStatusDisabled}
                value={isStatusDisabled ? loanDetails?.loan_status : modalLoanStatus}
                className={styles.modalSel}
                variant="outlined"
                onChange={statusChangeHandler}
              >
                {isStatusDisabled ? (
                  <MenuItem value={loanDetails?.loan_status} disabled>
                    {loanDetails?.loan_status}
                  </MenuItem>
                ) : (
                  loanStatusData.map((data) => (
                    <MenuItem key={data.statusId || data.statusCode} value={data.statusName}>
                      {data.statusName}
                    </MenuItem>
                  ))
                )}
              </TextField>
            </div>
            {selectedItem.disbursed && (
              <>
                <div className={styles.textArea}>
                  <label htmlFor="ref-number">Reference Number</label>
                  <TextField
                    size="small"
                    className={styles.modalSel}
                    variant="outlined"
                    value={disbursedVal.refNumber}
                    type="text"
                    onChange={(e) =>
                      setDisbursedVal((prevState) => ({
                        ...prevState,
                        refNumber: e.target.value,
                      }))
                    }
                    name="ref-number"
                    id="ref-number"
                  />
                </div>
                <div className={styles.textArea}>
                  <label htmlFor="disb-date">
                    NBFC Disbursement Date
                    <span
                      style={{
                        color: "grey",
                        fontSize: "12px",
                      }}
                    >
                      {" "}
                      (Reference disbursement date)
                    </span>
                  </label>
                  <TextField
                    size="small"
                    className={styles.modalSel}
                    variant="outlined"
                    value={disbursedVal.disbDate}
                    type="date"
                    required
                    onChange={(e) =>
                      setDisbursedVal((prevState) => ({
                        ...prevState,
                        disbDate: e.target.value,
                      }))
                    }
                    name="disb-date"
                    id="disb-date"
                    inputProps={{
                      max: new Date().toISOString().split("T")[0],
                    }}
                  />
                </div>
                <div className={styles.notifyCustomer}>
                  <label htmlFor="disb-notify">Notify Customer</label>
                  <input
                    type="checkbox"
                    id="disb-notify"
                    value={disbursedVal.notify}
                    onChange={(e) =>
                      setDisbursedVal((prevState) => ({
                        ...prevState,
                        notify: e.target.checked,
                      }))
                    }
                  />
                </div>
              </>
            )}
            {selectedItem.partlyDisbursed && (
              <PartlyDisbursedStatus
                loanId={loanDetails?.loan_id}
                setUtr={setUtr}
              />
            )}
            <div className={styles.textArea}>
              <label htmlFor="description">Description<span style={{ color: "red" }}>*</span></label>
              <textarea
                name="description"
                id="description"
                cols="30"
                rows="3"
                style={{ fontFamily: "inherit" }}
                value={descValue}
                onChange={(e) => setDescValue(e.target.value)}
                className={styles.modalText}
              ></textarea>
            </div>

            <button
              className={styles.loanStatusModalSubmit}
              onClick={submitLoanStatusHandler}
              disabled={isStatusDisabled}
            >
              SUBMIT
            </button>
            <div className={styles.CloseIcon} onClick={closeModal}>
              <CloseIcon />
            </div>
          </div>
        </div>

        {showFirstModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000
            }}
          >
            <div
              style={{
                background: "#fff",
                width: "520px",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                fontFamily: "Arial",
                overflow: "hidden"
              }}
            >
              {/* Header */}
              <div
                style={{
                  background: "#f5f5f5",
                  padding: "14px 20px",
                  fontWeight: "600",
                  fontSize: "16px",
                  borderBottom: "1px solid #e0e0e0"
                }}
              >
                Proceed Without Active NACH Mandate?
              </div>

              {/* Body */}
              <div style={{ padding: "20px" }}>
                <p style={{ marginBottom: "10px", lineHeight: "1.5" }}>
                  This loan does not have an active NACH mandate registered.
                </p>

                <p style={{ marginBottom: "16px", lineHeight: "1.5" }}>
                  An active NACH mandate is required before moving to Ready for Disbursement.
                </p>

                <p style={{ fontWeight: "600" }}>
                  Do you still want to proceed?
                </p>
              </div>

              {/* Footer */}
              <div
                style={{
                  background: "#f5f5f5",
                  padding: "12px 20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  borderTop: "1px solid #e0e0e0"
                }}
              >
                <button
                  style={{
                    padding: "8px 16px",
                    border: "1px solid #ccc",
                    background: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer"
                  }}
                  onClick={() => setShowFirstModal(false)}
                >
                  Cancel
                </button>

                <button
                  style={{
                    padding: "8px 16px",
                    background: "#1976d2",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    setShowFirstModal(false);
                    setShowSecondModal(true);
                  }}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        )}

        {showSecondModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000
            }}
          >
            <div
              style={{
                background: "#fff",
                width: "550px",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                fontFamily: "Arial",
                overflow: "hidden"
              }}
            >
              {/* Header */}
              <div
                style={{
                  background: "#d32f2f",
                  color: "#fff",
                  padding: "14px 20px",
                  fontWeight: "600",
                  fontSize: "16px"
                }}
              >
                ⚠ Critical Warning: Missing NACH Mandate
              </div>

              {/* Body */}
              <div style={{ padding: "20px" }}>
                <p style={{ marginBottom: "12px", lineHeight: "1.5" }}>
                  You are attempting to move the loan to Ready for Disbursement without an active
                  <b> NACH mandate</b>.
                </p>

                <p style={{ marginBottom: "10px" }}>This may lead to:</p>

                <ul style={{ paddingLeft: "20px", marginBottom: "16px", lineHeight: "1.6" }}>
                  <li>✔ Failed or delayed EMI collections</li>
                  <li>✔ Increased risk of delinquency & defaults</li>
                  <li>✔ Manual intervention for collections</li>
                  <li>✔ Compliance and audit issues</li>
                </ul>

                {/* Checkbox */}
                <div style={{ marginBottom: "20px" }}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    style={{ marginRight: "8px" }}
                  />
                  <span>I understand the risks and choose to proceed</span>
                </div>

                {/* Buttons */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <button
                    style={{
                      padding: "8px 16px",
                      border: "1px solid #ccc",
                      background: "#f5f5f5",
                      borderRadius: "4px",
                      cursor: "pointer"
                    }}
                    onClick={() => setShowSecondModal(false)}
                  >
                    Go Back & Register NACH
                  </button>

                  <button
                    disabled={!isChecked}
                    style={{
                      padding: "8px 16px",
                      background: isChecked ? "#1976d2" : "#ccc",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: isChecked ? "pointer" : "not-allowed"
                    }}
                    onClick={handleForceProceed}
                  >
                    Confirm & Proceed Anyway
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default LoanStatusModal;